import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./componentes/home/contenedor";
import GaleriaComponent from "./componentes/galeria/contenedor";
import Nosotros from "./componentes/nosotros/contenedro";
import Contacto from "./componentes/contacto/contenedor";
import Preguntas from "./componentes/preguntas/contenedor";
import ReactGA from "react-ga";

function App() {
  useEffect(() => {
    ReactGA.initialize("UA-179649391-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <BrowserRouter>
      <div className="App">
        <Switch>
          <Route exact path="/" component={Nosotros}></Route>
          <Route exact path="/servicios" component={Home}></Route>
          <Route exact path="/galeria" component={GaleriaComponent}></Route>
          <Route exact path="/preguntas" component={Preguntas}></Route>
          <Route exact path="/contacto" component={Contacto}></Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
